// extracted by mini-css-extract-plugin
export default {"element":"I","fromLeft":"J","fromRight":"K","fromBelow":"L","fromAbove":"M","appear":"N","blinking":"O","gradientShift":"P","float":"Q","move":"R","scroll":"S"};